import { apiClient } from '@/lib/api/client';
import type { FloorPlanResponse } from '@/features/booking/types/floorPlanTypes';

/** Shape of each element in the API response data array */
interface FloorPlanWrapper {
    floor_plan: FloorPlanResponse;
}

/**
 * Service for floor plan operations
 */
export const floorPlanService = {
    /**
     * Fetches all floor plans associated with a specific booking category
     * @param bookingCategoryId - The booking category ID
     * @returns Promise containing an array of floor plan responses
     */
    getFloorPlansByBookingCategory: async (
        bookingCategoryId: string
    ): Promise<FloorPlanResponse[]> => {
        try {
            const response = await apiClient.get<{ data: FloorPlanWrapper[] }>(
                `/api/public/v1/floor-plan/booking-category/${bookingCategoryId}/all`
            );
            // Unwrap: { data: [{ floor_plan: {...} }, ...] } → FloorPlanResponse[]
            return (response.data || []).map((wrapper) => wrapper.floor_plan);
        } catch (error) {
            console.error('Error fetching floor plans:', error);
            return [];
        }
    },
};
